import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { TipoRespaldoSubcategoria } from '../_models/tipo-respaldo-subcategoria';

@Injectable({
  providedIn: 'root'
})
export class TipoRespaldoSubcategoriaService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/tiposRespaldosSubCategorias/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as TipoRespaldoSubcategoria[] ) );
  }

  listadoPorIdRespaldoCategoria( id: string ) {
    return this.httpClient.get( this.rutServicio + 'tipoRespaldoCategoria/' + id ).pipe( map( res => res as TipoRespaldoSubcategoria[] ) );
  }

  listarTodosPorIdRespaldoCategoria( id: string ) {
    return this.httpClient.get( this.rutServicio + 'tipoRespaldoCategoria/' + id + '/all').pipe( map( res => res as TipoRespaldoSubcategoria[] ) );
  }

  listarTodosPorIdRespaldoCategoriaCodigoHabilitado( codigo: string ) {
    return this.httpClient.get( this.rutServicio + 'tipoRespaldoCategoria/code/' + codigo + '/enabled').pipe( map( res => res as TipoRespaldoSubcategoria[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as TipoRespaldoSubcategoria ) );
  }

  crear( regCrear: TipoRespaldoSubcategoria ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as TipoRespaldoSubcategoria ) );
  }

  actualizar( regActualizar: TipoRespaldoSubcategoria ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  buscar( str: string ) {
    return this.httpClient.get( this.rutServicio + 'buscar/' + str + '/' ).pipe( map( res => res as TipoRespaldoSubcategoria[] ) );
  }
}
